export default __webpack_public_path__ + "static/media/detail_main_img_10.677a687e.png";